export default class TextHelper {
  static romanNumerals = ['I', 'II', 'III', 'IV', 'VI', 'VII'];

  static truncateString(t: string, n: number) {
    return t.substr(0, n - 1) + (this.length > n ? '&hellip;' : '');
  }

  static prepositions = [
    'a',
    'al',
    'de',
    'del',
    'el',
    'la',
    'y',
    'o',
    'los',
    'que',
    'las',
    'en',
    'con',
    'por',
    'para'
  ];

  static exceptions = ['ti', 'tic', 'preg', 'cgt'];

  static evalText(t: string) {
    if (TextHelper.romanNumerals.includes(t.toUpperCase()))
      return t.toUpperCase();
    if (TextHelper.prepositions.includes(t.toLowerCase()))
      return t.toLowerCase();
    return `${t.toUpperCase().substring(0, 1)}${t.toLowerCase().slice(1)}`;
  }

  public static capitalize(text: string, ignoreLine = false) {
    const arrText = text?.toLowerCase().split(' ');

    let s: any = [];

    if (arrText?.length) {
      s = arrText.map((t: string) => {
        if (TextHelper.exceptions.includes(t)) {
          return t.toUpperCase();
        }

        let capitalizeText = '';
        capitalizeText = this.evalText(t)
          .split(ignoreLine ? ' ' : '-')
          .reduce((a, b) => `${this.evalText(a)} ${this.evalText(b)}`);

        return capitalizeText;
      });
    }

    return s.join(' ');
  }

  public static fixRomans(text: string) {
    const arrText = text?.split(' ');
    let s: any = [];
    if (arrText?.length) {
      s = arrText.map((t) => {
        const fixText = TextHelper.romanNumerals.includes(t.toUpperCase())
          ? t.toUpperCase()
          : t;
        return fixText;
      });
    }
    return s.join(' ');
  }

  public static elipsis(text: string, limit = 22) {
    let blocktext = text === null ? '' : text;
    if (blocktext.length > limit && limit) {
      if (limit === 1) {
        blocktext = `${text.charAt(0)}`;
      } else {
        blocktext = `${this.truncateString(text, limit).substring(
          0,
          blocktext.length - 2
        )}...`;
      }
    }
    return blocktext;
  }

  public static sortByName(a: any, b: any) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  }
}
